export const initialValue = {
    feeCountry: {
        value: "US",
        hasError: false,
    },
    feeState: {
        value: "",
        hasError: false,
    },
    feeCurrency: {
        value: "",
        hasError: false,
    },
    feeAmount: {
        value: "",
        hasError: false,
    },
    feeTaxable: {
        value: true,
        hasError: false,
    },
    feeTaxRate: {
        value: "",
        hasError: false,
    },
    feeActive: {
        value: true,
        hasError: false,
    },
    selfReg: {
        value: false,
        hasError: false,
    },
    description: {
        value: "",
        hasError: false,
    },
    startDate: {
        value: null,
        hasError: false,
    },
    endDate: {
        value: null,
        hasError: false,
    },
    isDeleted: {
        value: false,
        hasError: false,
    },
    feeRanges: {
        value: undefined,
        hasError: false,
    },
    feeRangeType: {
        value: undefined,
        hasError: false,
    },
    rule: {
        value: undefined,
        hasError: false,
    },
    metadata: {
        value: {},
    },
};